import script from "./checkChannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkChannel.vue?vue&type=script&lang=ts&setup=true"

import "./checkChannel.vue?vue&type=style&index=0&id=749c8f8e&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749c8f8e"]])

export default __exports__